import * as ActionType from '../constants/constant_action_types';

export function startDownload() {
  return { type: ActionType.INITIALIZE_DOWNLOADING_DATA };
}

export function resetDownload() {
  return { type: ActionType.DONE_DOWNLOADING_DATA };
}

export function immediateDownload(
  data,
  download,
  format,
  name,
  mimeType,
  isBlob,
) {
  return {
    type: ActionType.IMMEDIATE_DOWNLOAD,
    payload: {
      data,
      download,
      format,
      isBlob,
      mimeType,
      name,
    }
  }
}

export function searchRecordExportFileDownload(payload) {
  return {
    type: ActionType.SEARCH_RECORD_EXPORT_FILE_DOWNLOAD,
    payload,
  }
}

export function labelPrintFileDownload(payload) {
  return {
    type: ActionType.LABEL_PRINT_FILE_DOWNLOAD,
    payload,
  }
}
